import React, { useState, useEffect } from "react";

import { record } from "aws-amplify/analytics";

import Box from "@mui/material/Box";

import { CommonFooter } from "../Common/CommonFooter";
import { LatLngSearch } from "./LatLngSearch";

export default function Location() {
  const [isAvailable, setAvailable] = useState(false);
  const [position, setPosition] = useState({ latitude: null, longitude: null });

  useEffect(() => {
    // isFirstRef.current = false;
    if ("geolocation" in navigator) {
      setAvailable(true);
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setPosition({ latitude, longitude });
      });
    }
  }, [isAvailable]);

  // aws-amplify/analitycs
  record({
    name: "locationVisit",
  });

  return (
    <>
      <main>
        {(!isAvailable || !position.latitude || !position.longitude) && (
          <Box sx={{ m: 2 }}>位置情報が無効です</Box>
        )}
        {position.latitude && position.longitude && (
          <LatLngSearch position={position} />
        )}
      </main>
      <Box sx={{ my: 2 }}>
        <CommonFooter></CommonFooter>
      </Box>
    </>
  );
}
